import { Form, Col, Row, Button, Container, Alert } from "react-bootstrap";
import { useState, useEffect } from "react";
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import check from "../../assets/img/check.png";
import loadingImg from "../../assets/img/preload.gif";
import { getFirestore } from "../../config/firebase";
import emailjs from "emailjs-com";

const Formulario = () => {
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [status, setStatus] = useState(null);
  const [honeypot, setHoneypot] = useState("");
  const [formLoadTime, setFormLoadTime] = useState(0);
  const [selectedHorario, setSelectedHorario] = useState("");
  const [isOver18, setIsOver18] = useState(false);
  const [errors, setErrors] = useState({ email: "", phone: "" });
  const [showAlert, setShowAlert] = useState(false);
  const [tipoTemplate, setTipoTemplate] = useState("landingRangerExp");
  const db = getFirestore();

  const query = new URLSearchParams(window.location.search);
  const utm_source = query.get("utm_source") || sessionStorage.getItem("utm_source");
  const utm_medium = query.get("utm_medium") || sessionStorage.getItem("utm_medium");

  const [touched, setTouched] = useState({
    name: false,
    phone: false,
    email: false,
  });

  const [toSend, setToSend] = useState({
    name: "",
    email: "",
    phone: "",
    is_client: null,
    vehicle: "",
    ip: "",
    device: navigator.userAgent,
    origen: `${utm_source ? utm_source : ""}  ${utm_medium ? utm_medium : ""}`,
  });

  useEffect(() => {
    setFormLoadTime(Date.now());
    const fetchIP = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        setToSend((prevState) => ({ ...prevState, ip: data.ip }));
      } catch (error) {
        console.error("Failed to fetch IP address:", error);
      }
    };
    fetchIP();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "email") {
      validateEmail(value);
    }

    if (name === "phone") {
      validatePhone(value);
    }

    if (type === "checkbox") {
      setIsOver18(checked);
    } else if (type === "radio") {
      if (name === "is_client") {
        setToSend({ ...toSend, is_client: value === "yes" });
      } else {
        setSelectedHorario(value);
        setToSend({ ...toSend, horario: value });
      }
    } else {
      setToSend({ ...toSend, [name]: value });
    }

    setTouched((prev) => ({ ...prev, [name]: true }));
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
  };
  const handleSubmitClick = (e) => {
    if (!isOver18) {
      setShowAlert(true);
      e.preventDefault(); // Prevents any default action even if the button is disabled.
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (honeypot || !selectedHorario || !isOver18) {
      console.log("Validation failed");
      setStatus("error");
      return;
    }
    const submissionTime = Date.now();
    const timeElapsed = submissionTime - formLoadTime;
    if (timeElapsed < 5000) {
      console.log("Form submitted too quickly, likely a bot!");
      setStatus("error");
      return;
    }

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(true);
    setLoading(true);
    setStatus("cargando");

    //EMAIL JS (ONLY FOR BACKUP)
    let toSendForMail = { ...toSend, is_client: toSend.is_client ? "Sí" : "No" };
    emailjs.send("serviceGmail", tipoTemplate, toSendForMail, "user_EIC1ELQk7I3NPaFMEDa64");

    try {
      const inscriptosRef = doc(db, "ranger_experience", "inscriptos");
      await updateDoc(inscriptosRef, {
        inscriptos: arrayUnion({ ...toSend }),
      });
      setLoading(false);
      setStatus("ok");
    } catch (error) {
      console.error("Error writing document: ", error);
      setLoading(false);
      setStatus("error");
    }
  };

  const validateEmail = (email) => {
    const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    if (!emailPattern.test(email)) {
      setErrors({ ...errors, email: "Email debe tener el formato: ejemplo@ejemplo.com" });
    } else {
      setErrors({ ...errors, email: "" });
    }
  };

  const validatePhone = (phone) => {
    const phonePattern = /^\d{10}$/;
    if (!phonePattern.test(phone) || phone.length < 10) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phone: "Solo números, sin 0 y sin 15. Ej. 351 5 123456. Mínimo 10 dígitos.",
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, phone: "" }));
    }
  };

  const formIsValid =
    toSend.name &&
    toSend.phone &&
    toSend.email &&
    selectedHorario &&
    toSend.is_client !== null &&
    errors.email === "" &&
    errors.phone === "";

  console.log(toSend);

  return (
    <Container className="ps-4 pe-4">
      {status === null && (
        <>
          <Row className="intro">
            <Col>
              <div className="text-left" style={{ textAlign: "left" }}>
                <h2 className="pt-5 mt-2 text-start pb-5">
                  Completá el formulario y un asesor comercial te contactará por mail o WhatsApp para confirmar tu
                  participación.
                </h2>
                {/* <h2 className="pt-1 mt-2 pb-md-5 pb-4 fw-normal text-left"></h2> */}
              </div>
            </Col>
          </Row>

          <Form onSubmit={onSubmit} noValidate validated={validated}>
            <input
              type="text"
              name="hidden_field"
              style={{ display: "none" }}
              value={honeypot}
              onChange={(e) => setHoneypot(e.target.value)}
            />

            <Row className="mb-3">
              <Col md={4}>
                <Form.Group controlId="name">
                  <Form.Label>Nombre y apellido *</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    required
                    value={toSend.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.name && !toSend.name}
                  />
                  <Form.Control.Feedback type="invalid">Ingresá tu nombre.</Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4} className="pt-md-0 pt-3">
                <Form.Group controlId="phone">
                  <Form.Label>Número de celular *</Form.Label>
                  <Form.Control
                    type="text"
                    name="phone"
                    required
                    value={toSend.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, "");
                    }}
                    minLength={10}
                    maxLength={10}
                    isInvalid={(!!errors.phone && !toSend.phone) || (touched.phone && toSend.phone.length < 10)}
                  />

                  <Form.Control.Feedback type="invalid" style={{ fontSize: "12px" }}>
                    {errors.phone}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4} className="pt-md-0 pt-3">
                <Form.Group controlId="email">
                  <Form.Label>Email *</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    required
                    value={toSend.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={!!errors.email && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(toSend.email)}
                  />
                  <Form.Control.Feedback type="invalid" style={{ fontSize: "12px" }}>
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3 pt-1">
              <Col md={4} className="pt-1 pt-md-4">
                <Form.Group controlId="email">
                  <Form.Label>¿Sos cliente de Montironi?</Form.Label>
                  <Row>
                    <Col className="d-flex justify-content-start flex-row">
                      <Form.Check
                        type="radio"
                        label="Si"
                        name="is_client"
                        value="yes"
                        checked={toSend.is_client === true}
                        onChange={handleChange}
                        required
                      />
                      <Form.Check
                        type="radio"
                        label="No"
                        name="is_client"
                        value="no"
                        checked={toSend.is_client === false}
                        onChange={handleChange}
                        required
                        className="ms-4"
                      />
                      <Form.Control.Feedback type="invalid">Ingresá un email válido.</Form.Control.Feedback>
                    </Col>
                  </Row>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Label className="pt-4">
                  {toSend.is_client
                    ? `¿Cuál fue el último vehículo que nos compraste?`
                    : `¿Tenés vehículo actualmente? ¿Cuál?`}
                </Form.Label>
                <Form.Control type="text" name="vehicle" value={toSend.vehicle} onChange={handleChange} />
              </Col>
              <Col md={4} className="pt-md-0 mt-4">
                <Form.Label>¿En qué horario te gustaría asistir? *</Form.Label>
                <Row>
                  <Col md={4} xs={6}>
                    <Form.Check
                      type="radio"
                      label="09 a 11 hs."
                      name="timeOptions"
                      value="09 a 11"
                      checked={selectedHorario === "09 a 11"}
                      onChange={handleChange}
                      required
                    />
                  </Col>
                  <Col md={4} xs={6}>
                    <Form.Check
                      type="radio"
                      label="11 a 13 hs."
                      name="timeOptions"
                      value="11 a 13"
                      checked={selectedHorario === "11 a 13"}
                      onChange={handleChange}
                      required
                    />
                  </Col>
                  <Col md={4} xs={6}>
                    {" "}
                    <Form.Check
                      type="radio"
                      label="13 a 15 hs."
                      name="timeOptions"
                      value="13 a 15"
                      checked={selectedHorario === "13 a 15"}
                      onChange={handleChange}
                      required
                    />
                  </Col>
                  <Col md={4} xs={6}>
                    {" "}
                    <Form.Check
                      type="radio"
                      label="15 a 17 hs."
                      name="timeOptions"
                      value="15 a 17"
                      checked={selectedHorario === "15 a 17"}
                      onChange={handleChange}
                      required
                    />
                  </Col>
                  <Col md={4} xs={6}>
                    {" "}
                    <Form.Check
                      type="radio"
                      label="17 a 19 hs."
                      name="timeOptions"
                      value="17 a 19"
                      checked={selectedHorario === "17 a 19"}
                      onChange={handleChange}
                      required
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="mb-3 pt-2  pt-md-4 pb-1">
              <Col md={4}>
                <Form.Label>
                  <b>Fecha:</b> Jueves 12 de septiembre
                </Form.Label>
              </Col>
            </Row>
            <Row className="mb-3 pt-0 pb-2">
              <Col md={9}>
                <Form.Check
                  type="checkbox"
                  label="Soy mayor de 18 años y tengo licencia de conducir *"
                  name="ageVerification"
                  checked={isOver18}
                  onChange={handleChange}
                  required
                />
              </Col>
            </Row>

            <Row className="mb-3 pt-0 pb-0">
              <Col md={4}>
                <p className="campos_obligatarios mb-0">* Campos obligatorios</p>
              </Col>
            </Row>
            {showAlert && (
              <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible className="mb-4">
                Debes confirmar que eres mayor de 18 años y que tienes licencia de conducir.
              </Alert>
            )}

            <Button
              type="submit"
              className="btn-black w-100-moible"
              disabled={!formIsValid}
              onClick={handleSubmitClick}
            >
              {loading ? "Enviando..." : "Inscribite"}
            </Button>
          </Form>
        </>
      )}

      {status === "cargando" && (
        <div className="text-center mt-5 mb-5  pt-5 pb-5">
          <img src={loadingImg} alt="Cargando..." style={{ maxWidth: "150px" }} />
          <p>Enviando tus datos...</p>
        </div>
      )}

      {status === "ok" && (
        <div className="text-center mt-5 mb-5 pt-5 pb-5">
          <img src={check} alt="Enviado" style={{ marginBottom: "20px", maxWidth: "60px" }} />
          <p
            style={{
              fontWeight: "bold",
              fontSize: "22px",
              marginBottom: "0",
              textAlign: "center",
            }}
          >
            ¡Gracias por inscribirte!
          </p>
          <p style={{ textAlign: "center" }}>
            Te recordamos que los cupos son limitados. Un asesor comercial te contactará por mail o WhatsApp para
            confirmar tu participación y poder asistir al evento.
          </p>
        </div>
      )}

      {status === "error" && (
        <div className="text-center mt-5 mb-5  pt-5 pb-5">
          <p
            style={{
              color: "red",
              fontWeight: "bold",
              fontSize: "22px",
              marginBottom: "0",
              textAlign: "center",
            }}
          >
            Se ha producido un error
          </p>
          <p style={{ textAlign: "center" }}>Vuelva a intentarlo más tarde</p>
        </div>
      )}
    </Container>
  );
};

export default Formulario;
